import script from "./DeadlineFloorsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineFloorsTable.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineFloorsTable.vue?vue&type=style&index=0&id=ea8ab04e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea8ab04e"]])

export default __exports__